import type { IconData } from '@stacksjs/iconify-core'

export const userCircle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10m0-2a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-14a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V8a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V8a2 2 0 0 0-2-2M5.91 16.876a8 8 0 0 1-1.58-1.232a5.6 5.6 0 0 1 2.204-1.574a1 1 0 1 1 .733 1.86c-.532.21-.993.538-1.358.946zm8.144.022a3.65 3.65 0 0 0-1.41-.964a1 1 0 1 1 .712-1.868a5.65 5.65 0 0 1 2.284 1.607a8 8 0 0 1-1.586 1.225\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default userCircle
